
  export const inputClasses = (errors) =>
  errors ? "form-control is-invalid" : "form-control";
